var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69877 18.7919C6.24166 18.7919 5.85116 18.63 5.52727 18.3063C5.20353 17.9824 5.04167 17.5919 5.04167 17.1348V5.50024H4.125V4.12524H8.25V3.31445H13.75V4.12524H17.875V5.50024H16.9583V17.1348C16.9583 17.5979 16.7979 17.9898 16.4771 18.3107C16.1562 18.6315 15.7643 18.7919 15.3012 18.7919H6.69877ZM15.5833 5.50024H6.41667V17.1348C6.41667 17.2172 6.4431 17.2848 6.49596 17.3376C6.54882 17.3905 6.61642 17.4169 6.69877 17.4169H15.3012C15.3718 17.4169 15.4364 17.3875 15.4951 17.3287C15.5539 17.27 15.5833 17.2054 15.5833 17.1348V5.50024ZM8.62033 15.5836H9.9951V7.33358H8.62033V15.5836ZM12.0049 15.5836H13.3797V7.33358H12.0049V15.5836Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.7291a3e7e1ff31a9af67db2cc62d33b4.svg";
export { ForwardRef as ReactComponent };